
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill-current",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.56 7.3c.48-.52.76-1.25.88-2.14a4.4 4.4 0 00-.53-3.04A3.95 3.95 0 008.25.54 5.15 5.15 0 005.84 0C4.85 0 3.9.23 3.02.67A5.52 5.52 0 000 5.71c0 .93.18 1.76.54 2.48.36.73.9 1.3 1.58 1.7.7.4 1.5.61 2.4.61a6.6 6.6 0 001.7-.22 3.64 3.64 0 001.34-.58.36.36 0 00.08-.57l-.22-.27a.37.37 0 00-.3-.16.43.43 0 00-.24.07c-.2.14-.51.27-.95.38-.42.1-.85.16-1.3.16-.73 0-1.33-.15-1.82-.44-.5-.3-.89-.7-1.15-1.24a4.08 4.08 0 01-.4-1.84c0-1.01.21-1.85.63-2.54.44-.7 1-1.2 1.67-1.55a4.9 4.9 0 012.22-.52c.69 0 1.29.13 1.8.4.52.25.92.62 1.21 1.1.29.49.44 1.06.44 1.74 0 .26-.02.5-.06.7-.09.62-.27 1.07-.52 1.38-.23.31-.5.44-.81.44a.65.65 0 01-.53-.22.9.9 0 01-.21-.62v-.18h.01l.4-2.95a.35.35 0 00-.09-.3.39.39 0 00-.3-.15h-.46a.37.37 0 00-.37.25 1.98 1.98 0 00-1.12-.32A2.28 2.28 0 003 3.96a5 5 0 00-.27 1.28 6.03 6.03 0 00-.07 1.28c.06.47.28.86.65 1.15.38.29.86.42 1.41.42a2.19 2.19 0 001.53-.6c.14.17.31.3.52.4.3.15.63.22 1 .22.71 0 1.32-.27 1.8-.8zM6.1 7.28l.02-.02a1.81 1.81 0 00.07-.07m-.42-1.02v.01l-.01.02c-.08.22-.21.4-.4.54a1 1 0 01-.62.2.9.9 0 01-.61-.2.66.66 0 01-.24-.48v-.03a5.77 5.77 0 01.06-.9l.09-.66c.03-.14.06-.24.09-.3v-.02c.1-.23.25-.42.44-.56.2-.14.41-.2.67-.2.25 0 .42.07.55.19.15.14.22.3.22.5a7.88 7.88 0 01-.24 1.9z","fill":"#5B5858"}})])
          )
        }
      }
    